import ReactDOM from "react-dom/client";
import { Router } from "./router";
import { configureAmplify } from "./lib/amplify";
import { initNotifications } from "./stores/notification_store";
import "./styles/design-system.css";
import { fetchUser } from "./stores/user_store";

const root = document.getElementById("root");
if (root !== null) {
  configureAmplify();
  initNotifications();
  fetchUser();
  ReactDOM.createRoot(root).render(<Router />);
}
